import { PIPELINE_STAGES } from '@tipstrack/shared';

/** Colored pipeline-stage badge; color comes from a per-stage CSS class. */
export function StageBadge({ stageKey }: { stageKey: string }) {
  const stage = PIPELINE_STAGES.find((s) => s.key === stageKey);
  return <span className={`badge stage-${stageKey}`}>{stage?.label ?? stageKey}</span>;
}
